// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'object-status';

export const Component = () => (
  <path d='M9.038 4.501a1.237 1.237 0 0 1 1.047.647l.075.17.003.01L14.79 19.35l.03.056a.245.245 0 0 0 .322.057.222.222 0 0 0 .085-.097l2.53-6.526.008-.016.061-.13c.154-.296.384-.549.666-.732.323-.21.7-.32 1.086-.32H23a.5.5 0 1 1 0 1h-3.423a.994.994 0 0 0-.54.159.94.94 0 0 0-.354.417l-2.53 6.527a1.22 1.22 0 0 1-.484.567 1.249 1.249 0 0 1-1.389-.05 1.217 1.217 0 0 1-.435-.581l-.003-.01L9.216 5.65l-.03-.056a.246.246 0 0 0-.375-.012l-.034.054-2.542 5.828v-.001c-.152.352-.404.65-.726.86-.323.209-.7.32-1.086.32H1a.5.5 0 0 1 0-1h3.423a.995.995 0 0 0 .54-.16.939.939 0 0 0 .354-.416l.001-.003L7.86 5.235l.087-.163a1.249 1.249 0 0 1 1.09-.571z' />
);

export const viewBox = '0 0 25 25';
